import CwPluginRepository from '../../repositories/CwPluginRepository';

export default {
	namespaced: true,
	state: {
		//
	},
	mutations: {
		//
	},
	actions: {
		fetchCompany ({ getters }, company) {
			return CwPluginRepository.getCompany(company);
		},
		storeSettings ({ getters }, request) {
			return CwPluginRepository.storeSettings(request);
		},
		updateSettings ({ getters }, request) {
			return CwPluginRepository.updateSettings(request.setting_id, request.form);
		},
		fetchMonitorErrors ({ getters }) {
			return CwPluginRepository.getMonitorErrors();
		},
		clearError ({ getters }, id) {
			return CwPluginRepository.clearError(id);
		},
		clearSelectedErrors ({ getters }, selected) {
			return CwPluginRepository.clearSelectedErrors(selected);
		},
		clearAllErrors ({ getters }) {
			return CwPluginRepository.clearAllErrors();
		},
		ignoreError ({ getters }, id) {
			return CwPluginRepository.ignoreError(id);
		},
		ignoreSelectedErrors ({ getters }, selected) {
			return CwPluginRepository.ignoreSelectedErrors(selected);
		},
		ignoreAllErrors ({ getters }) {
			return CwPluginRepository.ignoreAllErrors();
		}
	},
	getters: {
	}
};
